import { useContext } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faLink,
  faCalendarWeek,
  faChartLine,
  faFile,
  faFileExport,
  faTruckLoading,
  faServer,
} from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

const ProviderTools = (props) => {
  const { providerPayload } = props

  const {
    callbacks: {
      editProviderTradingDays,
      exportProvider: exportFn,
      generateReport,
      manageProviderApiSettings,
      manageProviderOptions,
      manageProviderOrderDelivery,
    },
    loading,
  } = providerPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      exportProvider,
    },
  } = pageContext

  const exportProviderPayload = {
    callbacks: {
      action: exportFn,
    },
    toastText: 'Export Provider Queued',
  }

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faServer} />}
        marginBottom="medium"
        onClick={() => manageProviderApiSettings()}
        size="medium"
      >
        API Settings
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faFile} />}
        marginBottom="medium"
        onClick={() => manageProviderOrderDelivery()}
        size="medium"
      >
        File &amp; Order Delivery
      </Button>

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faTruckLoading} />}
          marginBottom="medium"
          onClick={() => manageProviderOptions()}
          size="medium"
        >
          Provider Options
        </Button>
      </ScopedConditionalContent>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faChartLine} />}
        marginBottom="medium"
        onClick={() => generateReport()}
        size="medium"
      >
        Generate Report
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCalendarWeek} />}
        onClick={() => editProviderTradingDays()}
        size="medium"
      >
        Edit Trading Days
      </Button>

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
        <Button
          buttonStyle="secondaryUtility"
          loading={loading}
          icon={<FontAwesomeIcon icon={faFileExport} />}
          marginTop="medium"
          onClick={() => exportProvider(exportProviderPayload)}
          size="medium"
        >
          Export Provider
        </Button>
      </ScopedConditionalContent>
    </Tools>
  )
}

ProviderTools.propTypes = {
  providerPayload: PropTypes.object.isRequired,
}

export default ProviderTools
